<template>
    <el-main :style="{ minHeight: height + 'px' }" v-loading="loading">
        <div class="Scroll_content children-home">
            <div class="top-section">
                <div class="stats-panel">
                    <div class="stat-cards">
                        <div class="stat-card">
                            <div>
                                <div class="stat-number" style="text-align: center;">{{ monthTotal || 0 }}</div>
                                <div class="stat-text">{{ $t('new_index.CurrentMonthLessons') }}</div>
                            </div>
                        </div>
                        <div class="stat-card">
                            <img class="stat-icon" src="../../assets/img/容器 1870.png" alt="">
                            <div>
                                <div class="stat-number">{{ children_info.month_complete || 0 }}</div>
                                <div class="stat-text">{{ $t('new_index.Completed') }}</div>
                            </div>
                        </div>
                        <div class="stat-card">
                            <img class="stat-icon" src="../../assets/img/容器 1871.png" alt="">
                            <div>
                                <div class="stat-number">{{ children_info.month_pending || 0 }}</div>
                                <div class="stat-text">{{ $t('new_index.Scheduled') }}</div>
                            </div>
                        </div>
                        <div class="stat-card">
                            <img class="stat-icon" src="../../assets/img/容器 1872.png" alt="">
                            <div>
                                <div class="stat-number">{{ monthRemaining }}</div>
                                <div class="stat-text">{{ $t('new_index.Remaining') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-section">
                <div class="tab-header">
                    <div class="tab-item" :class="{ active: activeTab === 'monthly' }" @click="switchTab('monthly')">{{
                        $t('new_header.MonthyuStatement') }}</div>
                    <div class="tab-item" :class="{ active: activeTab === 'transaction' }"
                        @click="switchTab('transaction')">{{ $t('new_header.TransactionOrderHistory') }}</div>
                </div>
                <div class="tab-content">
                    <MonthyuStatement v-if="activeTab === 'monthly'" :embedded="true" />
                    <Transaction v-else :embedded="true" />
                </div>
            </div>
        </div>

        <div v-if="dialogFormVisible" class="el-message-box__wrapper email-dialog-mask">
            <div class="el-message-box">
                <div class="el-message-box__header">
                    <div class="el-message-box__title center">
                        <b>{{ $t('new_index.editInfo') }}</b>
                    </div>
                    <button type="button" class="el-message-box__headerbtn" @click="closeEmailDialog">
                        <i class="el-message-box__close el-icon-close"></i>
                    </button>
                </div>
                <div class="el-message-box__content">
                    <div class="el-message-box__container">
                        <div class="el-message-box__message">
                            <p>{{ $t('information.Email') }}</p>
                            <el-input v-model="email" autocomplete="off" maxlength="50"></el-input>
                        </div>
                    </div>
                </div>
                <div class="el-message-box__btns">
                    <button type="button"
                        class="el-button el-button--default el-button--small el-button--primary save-btn"
                        @click="saveEmail">
                        <span>{{ $t('main.send') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </el-main>
</template>

<script>
import { setStore, getStore, keys } from '@/store'
import MonthyuStatement from './MonthyuStatement'
import Transaction from './Transaction'

export default {
    components: {
        MonthyuStatement,
        Transaction
    },
    data() {
        return {
            loading: false,
            height: 100,
            children_info: {},
            userInfo: {},
            activeTab: 'transaction',
            dialogFormVisible: false,
            email: '',
        }
    },
    computed: {
        monthTotal() {
            const info = this.children_info || {}
            if (info.month_total !== undefined && info.month_total !== null) {
                return info.month_total
            }
            if (info.month_lesson_count !== undefined && info.month_lesson_count !== null) {
                return info.month_lesson_count
            }
            return (info.month_complete || 0) + (info.month_pending || 0)
        },
        monthRemaining() {
            const info = this.children_info || {}
            if (info.month_remaining !== undefined && info.month_remaining !== null) {
                return info.month_remaining
            }
            return info.month_no_show || 0
        },
        greetingText() {
            const name = this.children_info.nickname || ''
            return this.$t('new_index.HelloParent', { name })
        },
        phoneText() {
            if (!this.userInfo.mobile) {
                return '-'
            }
            const code = this.userInfo.country_code ? '+' + this.userInfo.country_code + ' ' : ''
            return code + this.userInfo.mobile
        }
    },
    created() {
        this.height = document.body.offsetHeight - 104
        if (getStore(keys.token)) {
            if (getStore(keys.userInfo).status == 0) {
                this.$router.push({ path: '/onboarding' })
            }
        } else {
            this.$router.push({ path: '/' })
            return false
        }
        this.getUser()
    },
    methods: {
        switchTab(tab) {
            this.activeTab = tab
        },
        goAddChildren() {
            this.$router.push({ path: '/add-children' })
        },
        goInformation() {
            this.$router.push({ path: '/profile' })
        },
        openEmailDialog() {
            this.email = this.userInfo.email || ''
            this.dialogFormVisible = true
        },
        closeEmailDialog() {
            this.dialogFormVisible = false
        },
        saveEmail() {
            if (!this.email) {
                this.$message({
                    message: this.$t('errorprompt.emailEmpty'),
                    type: 'error'
                })
                return false
            }
            this.$http.post('/api/saveMail', { email: this.email }).then((res) => {
                if (res.data.code == 200) {
                    this.$message({
                        message: res.data.msg,
                        type: 'success'
                    })
                    this.closeEmailDialog()
                    this.getUser()
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'warning'
                    })
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        getUser() {
            this.loading = true
            this.$http.get('/api/member/data').then((res) => {
                if (res.data.code == 200) {
                    this.userInfo = res.data.data
                    this.children_info = res.data.data.student_info || {}
                    setStore(keys.userProfile, res.data.data)
                    if (this.$parent && this.$parent.$refs && this.$parent.$refs.children) {
                        this.$parent.$refs.children.up()
                    }
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'warning'
                    })
                }
                this.loading = false
            }).catch((error) => {
                console.log(error)
                this.loading = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
.top-section {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 32px;
}

.stats-panel {
    flex: 1;
    min-width: 0;
    text-align: center;
    max-height: 170px;
}

.stat-cards {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 10px;
}

.stat-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex: 1;
    gap: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 16px 12px;
}

.stat-icon {
    width: 42px;
    height: 42px;
}

.stat-number {
    font-size: 20px;
    font-weight: 500;
    color: #b50604;
    line-height: 1;
    text-align: left;
}

.stat-text {
    margin-top: 4px;
    font-size: 14px;
    color: #666;
}

.tab-section {
    overflow: hidden;
}

.tab-header {
    display: flex;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    padding: 0 24px;
}

.tab-item {
    padding: 16px 8px;
    margin-right: 32px;
    font-size: 16px;
    color: #666;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
}

.tab-item.active {
    color: #b50604;
    font-weight: 500;
    border-bottom-color: #b50604;
}

.tab-content {
    padding: 0;
}

.email-dialog-mask {
    z-index: 2010;
    background: rgba(0, 0, 0, 0.3);
}

.el-message-box {
    background: #fafafa;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    border-radius: 14px;

    .el-message-box__header {
        padding: 25px 84px;

        .el-message-box__title {
            margin-bottom: 10px;
            font-size: 24px;
        }

        .el-message-box__headerbtn {
            top: 25px;
        }
    }

    .el-message-box__content {
        color: #353643;
        padding: 22px 130px 50px;

        .el-message-box__message {
            .el-input {
                width: 100%;
                border-bottom: 1px solid #a5a5a5;
            }

            /deep/ .el-input__inner {
                height: 40px;
                border: none;
                background: none;
                font-size: 16px;
                color: #353643;
                outline: 0;
                padding: 0 40px 0 0;
                border-radius: 0;
            }

            >p {
                margin-bottom: 10px;
                font-weight: bold;
            }
        }
    }

    .el-message-box__btns .save-btn {
        height: 60px;
        background: #b50604;
        border-radius: 50px;
        font-size: 18px;
        color: #fff;
        border: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/children/ChildrenHome.vue